export default "/images/crossCircleIcon.svg?b3a6c4df7617d72d179d729f91a7d7d2";